import 'jspdf-autotable';
import {
  generateExcel,
  HEADER_COLOR,
  launchAlert,
  functionDidParseCell,
  functionWillDrawCell,
} from './mixin-export';
import alert from 'sweetalert2';
import axios from 'axios';
import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import jsPDF from 'jspdf';
import SweetAlert from 'src/class/Alerts';

const mixinExportWayuuReport = {
  methods: {
    exportTransportBonusToSAP() {
      launchAlert().then(() => {
        SweetAlert.download(
          i18n.t('mix.mixin_export.wait_while_excel_downloads'),
          alert
        );

        let response = axios({
          url: '/auth/works/wayuutransportbonus/sap',
          method: 'POST',
          data: { ...this.getDataToExportTransport },
          responseType: 'blob',
        });

        return response.then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'report_sap.xlsx');
          document.body.appendChild(link);
          link.click();
          alert.close();
        });
      });
    },

    exportRoomBonusToSAP() {
      launchAlert().then(() => {
        SweetAlert.download(
          i18n.t('mix.mixin_export.wait_while_excel_downloads'),
          alert
        );

        let response = axios({
          url: '/auth/works/wayuuroombonus/sap',
          method: 'POST',
          data: { ...this.getDataToExportBonus },
          responseType: 'blob',
        });

        return response.then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'report_sap.xlsx');
          document.body.appendChild(link);
          link.click();
          alert.close();
        });
      });
    },

    async exportXLSHeader(tableData, fileName, rowspanInfo) {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );

      setTimeout(async () => {
        const { data, headers } = await this.generateData(tableData);
        await generateExcel(true, fileName, headers, data, 7, ['F', 'G'], {
          columns: ['A', 'B', 'C', 'D'],
          rowspan: rowspanInfo,
        });
      }, 1000);
    },

    async exportToPDFHeader(tableData, fileName, rowspanInfoData) {
      SweetAlert.download(
        i18n.t('mix.mixin_export.wait_while_excel_downloads'),
        alert
      );

      setTimeout(async () => {
        const { data } = await this.generateData(tableData, true);
        const columns = [
          {
            header: `${i18n.t('common_words.name')} ${i18n.t('labor.worker')}`,
            dataKey: '0',
          },
          {
            header: i18n.t('common_words.document_cc'),
            dataKey: '1',
          },
          { header: i18n.t('labor.worker_code'), dataKey: '2' },
          { header: i18n.t('common_words.code_sap'), dataKey: '3' },
          { header: `N° ${i18n.t('common_words.working_days')}`, dataKey: '4' },
          { header: i18n.t('common_words.value'), dataKey: '5' },
          { header: i18n.t('common_words.total'), dataKey: '6' },
        ];
        const doc = new jsPDF({
          orientation: 'landscape',
          unit: 'mm',
          format: 'a4',
        });

        let body = [];
        body = data.map((row) => {
          const newRow = [...row];
          if (row[7]) {
            newRow.style = { fillColor: [253, 230, 228] };
          }
          row[7] = null;
          return newRow;
        });

        const headerStyle = {
          fillColor: HEADER_COLOR,
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          halign: 'left',
        };

        const rowspanInfo = {
          columns: ['0', '1', '2', '3'],
          rowspan: rowspanInfoData,
        };

        doc.autoTable({
          head: [columns.map((col) => col.header)],
          body: body,
          columns: columns,
          headStyles: headerStyle,
          didParseCell: function (data) {
            if (data.row.raw && data.row.raw.style) {
              data.cell.styles.fillColor = data.row.raw.style.fillColor;
            }
            functionDidParseCell(data, body, rowspanInfo);
          },
          margin: { top: 20, right: 10, bottom: 20, left: 10 },
          styles: {
            fontSize: 8,
            lineWidth: 0.1,
          },
          bodyStyles: {
            lineWidth: 0.1,
          },
          willDrawCell: function (data) {
            functionWillDrawCell(data, body, rowspanInfo);
          },
        });

        doc.save(`${fileName}.pdf`);
        alert.close();
      }, 1000);
    },

    generateData(tableData, isForPDF = false) {
      const data = tableData.map((header) => {
        const {
          worker_name,
          document_id,
          worker_code,
          bonus_homologated_code,
          days,
          bonus_value,
          total_bonus,
        } = header;
        const error = this.checkForErrors(header);

        return [
          worker_name,
          document_id,
          worker_code,
          bonus_homologated_code,
          days,
          isForPDF
            ? Formatter.formatNumber(Number(bonus_value))
            : Number(bonus_value),
          isForPDF
            ? Formatter.formatNumber(Number(total_bonus))
            : Number(total_bonus),
          error,
        ];
      });

      const headers = [
        `${i18n.t('common_words.name')} ${i18n.t('labor.worker')}`,
        i18n.t('common_words.document_cc'),
        i18n.t('labor.worker_code'),
        i18n.t('common_words.code_sap'),
        `${i18n.t('common_words.working_days')}`,
        i18n.t('common_words.value'),
        i18n.t('common_words.total'),
      ];

      return { headers, data };
    },

    checkForErrors(row) {
      const { days, payment_limit } = row;

      return Number(days) > Number(payment_limit) || Number(days) === 0;
    },
  },
};

export default mixinExportWayuuReport;
